import { RefinementCtx } from 'zod';
import { CreateTXUserFormValues, UpdateTXUserFormValues } from '@/types/customer';
import { getPhoneSchema, addCustomZodErrors } from '@/utils/helpers';

type CustomerTxCenter = {
  txCenter?: {
    allowedEmailDomains?: string[];
  };
};

type TxCenterData = {
  customerInTxCenters?: CustomerTxCenter[];
};

type DirectDomainsData = {
  allowedEmailDomains?: string[];
};

type BaseUserData = {
  primaryPhone?: string;
  email?: string;
};

function generalTxUserValidation<T extends BaseUserData>(
  data: T & (TxCenterData | DirectDomainsData),
  ctx: RefinementCtx,
) {
  const phoneSchemaResult = getPhoneSchema({ isRequired: true }).safeParse(data?.primaryPhone);
  const allowedDomainsCreate: string[] = 'allowedEmailDomains' in data ? data.allowedEmailDomains || [] : [];
  const allowedDomainsUpdate: string[][] =
    'customerInTxCenters' in data
      ? (data.customerInTxCenters?.map((item) => item?.txCenter?.allowedEmailDomains ?? []) ?? [])
      : [];

  const emailValue = data.email?.split('@')[1] || '';
  const isUpdateEmailValid = allowedDomainsUpdate.every((item) => {
    return item.length === 0 || item.includes(emailValue);
  });
  const isCreateEmailValid = allowedDomainsCreate.includes(emailValue);

  if (allowedDomainsCreate.length) {
    if (!isCreateEmailValid) {
      addCustomZodErrors({
        ctx,
        path: ['email'],
        message: "This domain is unavailable. Use your organization's domain or contact your administrator.",
      });
    }
  }

  if (allowedDomainsUpdate.length) {
    if (!isUpdateEmailValid) {
      addCustomZodErrors({
        ctx,
        path: ['email'],
        message: "This domain is unavailable. Use your organization's domain or contact your administrator.",
      });
    }
  }

  if (!phoneSchemaResult.success) {
    addCustomZodErrors({
      ctx,
      path: ['primaryPhone'],
      message: phoneSchemaResult.error.issues[0].message,
    });
  }
}

export const generalTxUserUpdateValidation = (data: UpdateTXUserFormValues, ctx: RefinementCtx) => {
  generalTxUserValidation(data, ctx);
};

export const generalTxUserCreateValidation = (data: CreateTXUserFormValues, ctx: RefinementCtx) => {
  generalTxUserValidation(data, ctx);
};
